// layout/constants.js
export const DRAWER_WIDTH = 280;

export const DRAWER_WIDTH_EXPANDED = 240;
export const DRAWER_WIDTH_COLLAPSED = 70;

